import moment from "moment"
import {LETTERS} from "@/views/Motivation/letters"

export default {
  balance: (state: any) => state.balance,

  periodText: (state: any) => {
    const {start_at, finish_at} = state.event || {}
    if (!start_at || !finish_at) return ""
    return `${moment(start_at).format("DD.MM.YYYY")} — ${moment(finish_at).format("DD.MM.YYYY")}`
  },

  balanceLetters: (state: any) =>
    LETTERS.map((letter) => ({
      letter,
      count: Number(state.balance?.[letter]) || 0,
    })),

  isPromoEnded: (state: any) => state.ended,

  bonuses: (state: any) => state.bonuses,
  bonusesCount: (state: any) => state.bonusesCount,
  availableBonuses: (state: any) => state.availableBonuses,
}
